<template>
  <div class="home">
    <div class="menu-wrapper" :class="{'menu-wrapper-close' : collapsed}">
      <a-popover placement="rightTop" v-model="visible" trigger="click" overlayClassName="home-person-card">
        <template slot="content">
          <div class="user-top">
            <div class="user-avatar">
              <zjy-avatar :url="userInfo.avatar" :size="60" :name="userInfo.name"/>
              <img v-if="userInfo.genderDesc"
                :src="userInfo.genderDesc === '男' ? require('@/assets/home/man.png') : userInfo.genderDesc === '女' ? require('@/assets/home/woman.png') : ''" />
            </div>
            <div class="user-name">
              <div class="user-name-title">{{ userInfo.name }}</div>
              <div class="user-name-text">{{ companyName }}</div>
            </div>
          </div>
          <div class="user-info" v-if="userInfo.userType === 'emp'">
            <div class="user-info-text"><span>工号：</span>{{ userInfo.code }}</div>
            <div class="user-info-text"><span>部门：</span>{{ userInfo.orgName }}{{ userInfo.label ? ' · ' + userInfo.label : '' }}</div>
            <div class="user-info-text"><span>手机号：</span>{{ userInfo.phone }}</div>
          </div>
          <div class="user-info" v-else>
            <div class="user-info-text"><span>学号：</span>{{ userInfo.code }}</div>
            <div class="user-info-text"><span>班级：</span>{{ userInfo.clazzName }}</div>
            <div class="user-info-text"><span>手机号：</span>{{ userInfo.phone }}</div>
          </div>
          <div class="bottom-btn">
            <div class="button" @click="handleBarClick('PersonIndex')">个人中心</div>
            <div class="button" @click="handleLogoutClick">退出登录</div>
	          <template v-if="userInfo.isAdmin || userInfo.isPlatformAdmin">
		          <a-divider style="margin: 10px 0!important;"></a-divider>
		          <div v-if="userInfo.isAdmin" class="button" @click="handleAdminClick">服务中台<a-icon style="color: #a5a5a7" type="right" /></div>
		          <div class="button" @click="handleClientAdminClick">管理后台<a-icon style="color: #a5a5a7" type="right" /></div>
	          </template>
          </div>
        </template>
        <div class="menu-wrapper-avatar">
          <zjy-avatar :size="35" :url="userInfo.avatar" :name="userInfo.name"/>
	        <div style="display: flex;align-items: flex-start;height: 100%">
		        <span>{{ userInfo.name }}</span>
	        </div>
        </div>
      </a-popover>
      <div class="bar-list">
        <a-tooltip :title="collapsed ? '消息': ''" placement="right">
          <div @click="handleBarClick('MessageIndex')" class="bar" :class="{ active: activeItem === 'MessageIndex' }">
            <img :src="require('@/assets/home/icon-news.svg')" alt="" />
            <div class="bar-list-text">消息</div>
            <div class="unreadMessageNum"> <a-badge :count="$store.getters.unreadMessageNum" :overflow-count="99" /></div>
          </div>
        </a-tooltip>
        <a-tooltip :title="collapsed ? '应用中心': ''" placement="right">
          <div @click="handleBarClick('WorkHomeIndex')" class="bar" :class="{ active: activeItem === 'WorkHomeIndex' }">
            <img :src="require('@/assets/home/icon-applys.svg')" alt="" />
            <div class="bar-list-text">应用中心</div>
          </div>
        </a-tooltip>
        <a-tooltip :title="collapsed ? '通讯录': ''" placement="right">
          <div v-if="userInfo.userType === 'emp'" @click="handleBarClick('ContactsIndex')" class="bar" :class="{ active: activeItem === 'ContactsIndex' }">
            <img :src="require('@/assets/home/icon-addresss.svg')" alt="" />
            <div class="bar-list-text">通讯录</div>
          </div>
        </a-tooltip>
	      <template v-if="navigationList.length > 0">
		      <div style="margin: 0 8px">
			      <a-divider style="margin: 12px 0!important;background-color: #6B7387!important;"/>
		      </div>
          <span v-for="(navigation, index) in navigationList" :key="index">
            <a-tooltip :title="collapsed ? navigation.name: ''" placement="right">
              <div @click="handleNavigationClick(navigation)"  class="bar" :class="{ active: $route.name === navigation.code }">
                <img :src="filePreview(navigation.iconId)" alt="" />
                <div class="bar-list-text">{{navigation.name}}</div>
              </div>
            </a-tooltip>
          </span>
	      </template>
      </div>
      <div class="bar-list bar-bottom">
        <a-tooltip :title="collapsed ? '小程序': ''" placement="right">
        <div class="bar" @click="programPanelShow">
          <img :src="require('@/assets/home/icon-xcx.svg')" alt="" />
          <div class="bar-list-text">小程序面板</div>
        </div></a-tooltip>
        <a-popover placement="rightBottom" v-model="previewVisible" trigger="click" overlayClassName="bar-bottom-card">
          <template slot="content">
            <div class="program">
              <div class="program-list" v-for="(item, index) in programList" :key="index" @click="showPreview(item)">
                <img :src="filePreview(item.icon)" alt="" />
                <div class="program-name">{{item.name}}</div>
              </div>
            </div>
          </template>
          <div class="bar" v-if="isShowPreview" @click="previewVisible = true" :class="{ active: previewVisible === true }">
            <img :src="require('@/assets/home/icon-phone.svg')" alt="" />
            <div class="bar-list-text">正在预览</div>
          </div>
        </a-popover>
      </div>
      <div class="menu-close">
        <span @click="collapsed = !collapsed"><a-icon :type="collapsed ? 'caret-right' : 'caret-left'" /></span>
      </div>
    </div>
    <program-panel ref="programPanelRef" />
    <div class="content-wrapper">
      <change-pwd ref="changePwd" :required="changePasswordRequired"/>
      <workplace-view v-show="isWork" />
	    <navigation-view v-show="isNavigation" />
      <keep-alive :exclude="['PersonIndex']">
        <router-view v-if="!isWork && !isNavigation" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import WorkplaceView from '@/views/home/workplace/WorkplaceView.vue'
import NavigationView from '@/views/home/navigation/NavigationView.vue'
import {mapGetters, mapState} from "vuex"
import Watermark from '@/utils/waterMark.js'
import { getCompanySetting } from "@/api/config"
import ZjyAvatar from "@/components/zjy/ZjyAvatar.vue";
import { getDefaultPasswordRequired } from "@/api/home";
import changePwd from "@/views/home/person/safe/ChangePwd.vue";
import {getCurrentNavigation, getSsoHost} from "@/api/home";
import storage from "store";
import {TENANT} from "@/store/mutation-types";
import ProgramPanel from '@/views/home/program/ProgramPanel.vue'
import ProgramPreview from "@/views/home/program/ProgramPreview.vue";
export default {
  name: 'HomeView',
  components: {
    changePwd,
    WorkplaceView,
	  NavigationView,
    ZjyAvatar,
    ProgramPanel,
  },
  data() {
    return {
      visible: false,
      companyName: undefined,
      messageBadge: 0,
      changePasswordRequired: false,
	    navigationList: [],
      previewVisible: false,
      isShowPreview: false,
      programUrl: '',
      programId: '',
      collapsed: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo','info']),
    ...mapState({
      programList: state => state.tabs.programIframeList,
    }),
    isWork() {
      return this.$route.name === 'WorkHomeIndex' || this.$route.meta.type === 'app'
    },
	  isNavigation() {
		  return this.$route.name === 'NavigationIndex' || this.$route.meta.type === 'navigation'
	  },
    activeItem() {
      if (this.isWork) {
        return 'WorkHomeIndex'
      } else if (this.$route.path.indexOf('/home/message') >= 0) {
        return 'MessageIndex'
      } else if (this.$route.path.indexOf('/home/contacts') >= 0) {
        return 'ContactsIndex'
      } else if (this.$route.path.indexOf('/home/person') >= 0) {
        return 'PersonIndex'
      } else if (this.$route.path.indexOf('/home/navigation') >= 0) {
	      return 'NavigationIndex'
      }
      return 'MessageIndex'
    }
  },
  methods: {
	  getCurrentNavigation() {
		  getCurrentNavigation().then(res => {
			  if (res.success) {
				  this.navigationList = res.data
			  }
		  })
	  },
    getCompanySetting() {
      getCompanySetting().then(res => {
        if (res.success) {
          this.companyName = res.data.unitName;
          if (this.$route.name === 'ContactsIndex') {
            Watermark.set(this.userInfo.name + ' - ' + this.companyName)
          }
        }
      })
    },
	  handleAdminClick() {
		  getSsoHost().then(res => {
				if (res.success) {
					window.open(res.data + "/admin/frontend", '_blank');
				}
		  })
    },
	  handleClientAdminClick() {
      let url = this.$router.resolve({ name: "AdminIndex", });
      window.open(url.href, '_blank');
    },
    handleLogoutClick() {
      this.visible = false
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.$store.dispatch('Logout').then(() => {
            location.reload()
          })
        },
        onCancel() {
        }
      })
    },
	  handleNavigationClick(navigation) {
      Watermark.set('')
			if (navigation.openType === 1) {
				this.$store.dispatch('AddNavigationIframe', navigation).then(() => {
					this.$router.push({ name: navigation.code })
				})
			} else {
				window.open(navigation.pcUrl, '_blank')
			}

		  // this.$router.push({name: 'NavigationIndex'})
	  },
    handleBarClick(routeName) {
      if (routeName === 'ContactsIndex') {
        Watermark.set(this.userInfo.name + (this.companyName ? ' - ' + this.companyName : ''))
      } else {
        Watermark.set('')
      }
      if (routeName === 'WorkHomeIndex') {
        if (this.$store.getters.currentTab) {
          this.$router.push({ name: this.$store.getters.currentTab.code })
          return
        }
      }
      if (routeName === 'PersonIndex') {
        this.visible = false
      }
			this.$router.push({name: routeName})
		},
	  handleImMessage() {
			this.$store.dispatch('GetUnreadMessageNum')
	  },

    changePasswordOpen(){
      getDefaultPasswordRequired().then(res=>{
        if(res.success && res.data){
          this.changePasswordRequired = true
          this.$refs.changePwd.open()
        }
      })
    },
    programPanelShow() {
      this.$refs.programPanelRef.show()
    },
    showPreview(item) {
	    item.visible = true
    }
	},
	created() {
		window.addEventListener('imMessage', this.handleImMessage)
		this.getCompanySetting()
		this.$store.dispatch('GetUnreadMessageNum')
	},
  mounted() {
    this.changePasswordOpen();
		this.getCurrentNavigation();
  },
  watch: {
    programList(newVal) {
      if (newVal.length === 0) {
        this.previewVisible = false
      }
      this.isShowPreview = newVal && newVal.length > 0;
    },
  },
}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  .menu-wrapper {
    background-color: #465069;
    box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.1);
    padding: 25px 10px 10px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .menu-wrapper-avatar {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      width: 140px;
	    cursor: pointer;
      span {
        color: white;
        flex: 1;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 10px;
      }
    }

    .avatar {
      font-weight: 700;
      cursor: pointer;
      /deep/.avatar-name {
        background: #fff;
        color: #3e7dff;
        font-size: 16px !important;
      }
    }

    .bar-list {
      display: flex;
      flex: 1;
      flex-direction: column;
      width: 100%;
      .bar {
        height: 32px;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        cursor: pointer;
        color: #fff;
        font-size: 14px;
        line-height: normal;
        padding: 0 8px 0 8px;
        overflow: hidden;
        border-radius: 4px;
        .bar-list-text {
          white-space: nowrap;
        }
        img {
          margin-bottom: -1px;
          opacity: 0.5;
          margin-right: 10px;
          width: 16px;
          height: 16px;
        }
        &.active {
          background: rgba(255, 255, 255, .2);
          color: #fefefe;

          //.bar-list-text {
          //  opacity: 1;
          //}

          img {
            opacity: 1;
          }
        }
        &:hover {
          background: rgba(255, 255, 255, .1);
        }
        .unreadMessageNum {
          flex: 1;
        }
      }

      .ant-badge {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        float: right;
        /deep/.ant-badge-count {
          background-color: #f54a45;
          box-shadow: none;
          min-width: 16px;
          height: 16px;
          line-height: 16px;
          padding: 0;
          font-size: 10px;
        }
      }
    }
    .bar-bottom {
      flex: none;
    }
    &-close {
      width: 46px;
      padding: 25px 8px 10px 8px;
      .menu-wrapper-avatar {
        width: auto;
        span {
          display: none;
        }
      }
      .bar-list {
        .bar {
          padding: 0 7px;
          height: 30px;
        }
      }
    }
    .menu-close {
      position: absolute;
      width: 12px;
      height: 100%;
      top: 0;
      right: 1px;
      transition: all .3s cubic-bezier(.2,0,0,1) 0s;
      display: flex;
      align-items: center;
      span {
        opacity: 0;
        height: 65px;
        line-height: 65px;
        width: 12px;
        border-radius: 8px;
        background: rgb(191,196,203);
        cursor: pointer;
      }
      &:hover {
        span {
          opacity: 1;
        }
      }
    }
  }

  .content-wrapper {
    display: flex;
    flex: 1;
    padding: 6px 6px 6px 0;
    background-color: #465069;
  }
}

.home-person-card {
  .user-top {
    display: flex;
    align-items: center;
    padding: 20px 4px;
    width: 268px;
    .user-avatar {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 100%;
      position: relative;
      /deep/.ant-avatar {
        //background: #fff !important;
        //color: #3e7dff !important;
        font-size: 24px !important;
      }

      img {
        position: absolute;
        right: -3px;
        bottom: -1px;
      }
    }

    .user-name {
      margin-left: 12px;
      flex: 1;
      width: 0;
      .user-name-title {
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0px;
        margin-bottom: 6px;
        color: #05051a;
      }

      .user-name-text {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0px;
        color: #646a73;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .user-info {
    border-bottom: 1px #ececec solid;
    padding: 0 4px 20px 4px;

    .user-info-text {
      font-size: 14px;
      line-height: 32px;
      letter-spacing: 0px;
      color: #787889;

      span {
        color: #a5a5a7;
        display: inline-block;
        width: 60px;
      }
    }
  }

  .bottom-btn {
    padding: 10px 0 0;

    .button {
      line-height: 38px;
      border-radius: 6px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #5e5e65;
      padding: 0 12px;
      margin: 0 -6px;
      &:hover {
        background: rgba(31, 35, 41, 0.08);
      }
    }
  }
}
.program {
  width: 205px;
  .program-list {
    display: flex;
    align-items: center;
    padding: 8px;
    cursor: pointer;
    font-size: 14px;
    line-height: normal;
    margin: 0 -7px;
    border-radius: 3px;
    &:hover {
      background: rgba(31, 35, 41, 0.08);
    }
    //&:last-child {
    //  padding-bottom: 6px;
    //}
    .program-name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 19px;
    }
    img {
      margin-right: 15px;
      width: 30px;
      height: 30px;
      border-radius: 100%;
    }
  }
}
</style>
